import { render, staticRenderFns } from "./warning.vue?vue&type=template&id=26d126d2&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d126d2",
  null
  
)

export default component.exports